export const MuiBreadcrumbs = {
    styleOverrides: {
        root: {},
        ol: {
            paddingBottom: '.5rem',
        },
        li: ({ theme }) => ({
            // Flex is necessary to proper home svg icon positioning.
            display: 'flex',
            color: theme.palette.text.muted,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '1.25rem',
            height: '1.25rem',
            ':hover': {
                color: theme.palette.text.medium,
            },
            '> a': {
                color: 'inherit',
                textDecoration: 'unset',
                svg: {
                    verticalAlign: 'text-top',
                    paddingTop: '1px',
                },
            },
        }),
        separator: ({ theme }) => [
            {
                color: theme.palette.neutral.light,
                flexShrink: 0,
                width: '1.25rem',
                height: '1.25rem',
            },
            theme.applyStyles('dark', {
                color: theme.palette.text.translucent,
            }),
        ],
    },
};
